import styles from "./Select.module.css";

interface SelectOption {
  readonly value: string;
  readonly label: string;
}

interface SelectProps {
  readonly name: string;
  readonly options: readonly SelectOption[];
  readonly value?: string;
  readonly onChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  readonly dark?: boolean;
  readonly className?: string;
  readonly "aria-label"?: string;
}

export function Select({
  name,
  options,
  value,
  onChange,
  dark,
  className,
  "aria-label": ariaLabel,
}: SelectProps) {
  return (
    <select
      name={name}
      value={value}
      onChange={onChange}
      aria-label={ariaLabel}
      className={`${styles.select} ${dark ? styles.dark : ""} ${className ?? ""}`}
    >
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
}
